import FilterBeachSurface from './FilterBeachSurface';

export default FilterBeachSurface;
